import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import A11y from 'chameleon/ui-stack/utilities/a11y';

export const SPPPerformanceBar = (props) => {
  const {
    studentScore,
    spp: {
      progress: { started },
    },
    customClasses,
    onClick = () => {},
    role = 'button',
  } = props;

  const getBarProps = () => {
    if (studentScore && !started) {
      // submitted
      return {
        classNames: 'text-pink-200 bg-purple-700',
        label: `${Math.ceil(studentScore.percentCorrect)}% Answered`,
        onClick: (e) => {
          onClick(e);
        },
      };
    } else if (studentScore && started) {
      // started but not submitted
      return {
        classNames: 'text-purple-700 bg-pink-200 cursor-default',
        label: `${Math.ceil(studentScore.percentCorrect)}% Answered`,
        onClick: (e) => {
          e.stopPropagation();
        },
      };
    }
    return {
      classNames: 'text-black bg-gray-400 cursor-default',
      label: 'Not Started',
      onClick: (e) => {
        e.stopPropagation();
      },
    };
  };

  const barProps = getBarProps();

  return (
    <A11y>
      <div
        className={cn(
          'w-full flex justify-center items-center h-14 rounded-full text-center',
          customClasses || 'text-14',
          barProps.classNames,
        )}
        onClick={barProps.onClick}
        /* eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex */
        tabIndex="0"
        role={role}
      >
        {barProps.label}
      </div>
    </A11y>
  );
};

SPPPerformanceBar.displayName = 'SPPPerformanceBar';
SPPPerformanceBar.propTypes = {
  spp: PropTypes.object.isRequired,
  studentScore: PropTypes.object,
  customClasses: PropTypes.string,
};

SPPPerformanceBar.defaultProps = {
  studentScore: 0,
  customClasses: '',
};
